var _path, _rect, _rect2, _rect3, _rect4, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCiscoDnaCenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.75,21.25h-1.5V57.24219C55.10352,56.95361,48.044,48.481,40.57617,39.52,33.09082,30.5376,25.35156,21.25,10,21.25a.7502.7502,0,0,0-.75.75V58.75h1.5V22.75781C24.89648,23.04639,31.95605,31.519,39.42383,40.48,46.90918,49.4624,54.64844,58.75,70,58.75a.7502.7502,0,0,0,.75-.75Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.25,
    y: 28,
    width: 1.5,
    height: 24
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.25,
    y: 34,
    width: 1.5,
    height: 12
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 61.25,
    y: 28,
    width: 1.5,
    height: 24
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 53.25,
    y: 34,
    width: 1.5,
    height: 12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14,58.75c10.27246,0,18.07031-8.1958,24.57227-15.87842l-1.14454-.96875C31.14258,49.32812,23.63086,57.25,14,57.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66,21.25c-10.27246,0-18.07031,8.1958-24.57227,15.87842l1.14454.96875C48.85742,30.67188,56.36914,22.75,66,22.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCiscoDnaCenter);
export default __webpack_public_path__ + "static/media/icon_cisco_dna_center.3ed094e7e782c182a722573719ad133e.svg";
export { ForwardRef as ReactComponent };